var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"machine-img"},[_c('img',{staticClass:"thumbnail-img",attrs:{"src":_vm.displayImg,"alt":"機械画像"}})])}
var staticRenderFns = []

export { render, staticRenderFns }